<template>
    <div>
        <h1>Adminina Karanteenissa</h1>
        <p>Vahtii moderaattoreita, operaattoreita ja omistaa kai vaikutusvaltaa palvelimen asioissa.</p>
        <h2>
            Lista Adminina aukeavista oikeuksista
        </h2>
        <ul class="command-list">
            <li>Käytännössä kaikki kaikki aukeaa.</li>
            <li>/op</li>
            <li>:)</li>
            <li>Quickshop admin käyttö</li>
            <li>restarter.restart</li>
            <li>Peliajan lisääminen, vähentäminen</li>
            <li>Tätä päivitetään myöhemmin...</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'admin',
    props: {},
    metaInfo: {
        title: 'Admin'
    }
}
</script>

<style scoped></style>
